import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  age: number;
  avatar: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Lo peor no era perder la erección. Lo peor era vivir pensando que iba a volver a pasar. Hoy me siento libre de esa carga.',
  name: 'Diego',
  age: 35,
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80'
}, {
  quote: 'Volví a sentirme seguro después de mucho tiempo. Pude dejar de pensar tanto durante el acto y simplemente disfrutar.',
  name: 'Javier',
  age: 41,
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80'
}, {
  quote: 'Dejé de evitar situaciones por miedo a fallar. Mi pareja notó el cambio enseguida, la confianza que recuperé no tiene precio.',
  name: 'Franco',
  age: 28,
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80'
}, {
  quote: 'Pensé que era un problema físico. Cuando entendí la parte mental y apliqué el sistema, mi control cambió completamente.',
  name: 'Martín',
  age: 38,
  avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=150&q=80'
}];
export function TestimonialsSection() {
  return <section className="relative w-full bg-black py-12 md:py-16 overflow-hidden" data-id="element-466">
      <div className="absolute inset-0 z-0" data-id="element-467">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-red-800/10 blur-[150px]" data-id="element-468" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-469" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-470" />

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-471">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-472">
          <div className="text-center mb-10" data-id="element-473">
            <h2 className="font-display text-3xl md:text-5xl uppercase text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-474">
              Hombres reales, cambios reales
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-475">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/30 rounded-xl p-6 shadow-[0_0_20px_rgba(220,38,38,0.05)] flex flex-col" data-id="element-476">
                <div className="flex items-center justify-between mb-4" data-id="element-477">
                  <QuoteIcon className="w-6 h-6 text-red-500/50" fill="currentColor" data-id="element-478" />
                  <div className="flex items-center gap-0.5" data-id="element-479">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 text-yellow-500 fill-yellow-500" data-id="element-480" />)}
                  </div>
                </div>

                <p className="text-base text-gray-300 leading-relaxed mb-6 flex-grow italic" data-id="element-481">
                  "{t.quote}"
                </p>

                <div className="flex items-center gap-4 pt-4 border-t border-red-900/20" data-id="element-482">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-red-500/30 grayscale-[20%]" loading="lazy" data-id="element-483" />
                  <div data-id="element-484">
                    <p className="text-white font-semibold text-sm" data-id="element-485">
                      {t.name}, {t.age} años
                    </p>
                    <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-486">
                      Cliente verificado
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}